import html2Canvas from 'html2canvas/dist/html2canvas.js'
export default{
  install(Vue,options) {
    Vue.prototype.ExportImage = function (response) {
      let exportDom = document.querySelector(response.el);
      exportDom.style.background = '#FFFFFF'
      let vm = this;
      /* 这部分代码用来解决生成的图片不清晰的问题 */
      let tableWidth = exportDom.offsetWidth;
      let tableHeight = exportDom.offsetHeight;
      let canvas = document.createElement('canvas');
      canvas.width = tableWidth * 2;
      canvas.height = tableHeight * 2;
      canvas.style.width = tableWidth + 'px';
      canvas.style.height = tableHeight + 'px';
      document.body.appendChild(canvas);
      var context = canvas.getContext('2d');
      context.scale(2, 2);
      /* 这部分代码用来解决生成的图片不清晰的问题 */
      html2Canvas(exportDom, {
        // canvas: canvas,
        onrendered (image) {
          var url = image.toDataURL();
          let a = document.createElement('a');
          a.href = url;
          a.download = vm.imageName ? vm.imageName : response.fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      });
      exportDom.style.background = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ExportImage.js